module.exports = "/images/SS-Logo-Black.png?c8ae4546f9a27c8234e3019c2d58d736";